import PrivacyContent from "../components/PrivacyContent/PrivacyContent";
import PublicLayout from "../components/Layout/PublicLayout";

const Privacy = () => {
    return(
    <PublicLayout>
        <PrivacyContent />
    </PublicLayout>
)
}

export default Privacy;

